
import Header from './Header';
import Footer from './Footer';
import { Outlet } from 'react-router-dom';

export default function PublicLayout() {
    return (
        <>
            <Header />
            <Outlet />
            <Footer />
        </>
    )
}